<template>
    <div class="honor">
        <div class="title wow fadeInUp">
            <p>Environmental<br>
                Showcase</p>
            <p>{{$t('about').honor}}</p>
        </div>
        <div class="allImgs wow fadeInUp">
            <div class="lc">

            </div>
            <div class="rc">

            </div>
            <swiper class="swiper" :options="swiperOption" ref="mySwipers">
                <swiper-slide class="item" v-for="(item,index) in environmental" :key="index">
                 <div class="one">
                     <img :src="`http://runbo.sansg.com/${item.picurl}`" alt="">
                 </div>
                    <p>{{item.title}}</p>
                </swiper-slide>
            </swiper>
            <swiper class="swiper swiper2" :options="swiperOption2" ref="mySwipers2">
                <swiper-slide class="item" v-for="(item,index) in environmental" :key="index">
                    <div class="one">
                        <img :src="`http://runbo.sansg.com/${item.picurl}`" alt="">
                    </div>
                    <p>{{item.title}}</p>
                </swiper-slide>
            </swiper>
        </div>
    </div>
</template>

<script>
    import { swiper, swiperSlide } from "vue-awesome-swiper";
    import "swiper/dist/css/swiper.css";
    export default {
        name: "honor",
        data(){
            return{
                swiperOption:{
                    centeredSlides : true,
                    slideToClickedSlide: true,
                    notNextTick: true,
                    slidesPerView:5,//一行显示3个
                    speed:1000,
                    init:true,
                    loop:true,
                    spaceBetween :10,
                    setWrapperSize :true,
                    autoplay: false
                },
                swiperOption2:{
                    centeredSlides : true,
                    slideToClickedSlide: true,
                    notNextTick: true,
                    slidesPerView:1,//一行显示3个
                    speed:1000,
                    init:true,
                    loop:true,
                    spaceBetween :10,
                    setWrapperSize :true,
                    autoplay: false
                },
                // list:[
                //     {
                //         img:require('../assets/rj/zp.png'),
                //         title:'车间场景'
                //     },
                //     {
                //         img:require('../assets/rj/zp.png'),
                //         title:'装配车间'
                //     },
                //     {
                //         img:require('../assets/rj/zp.png'),
                //         title:'车间场景'
                //     },
                //     {
                //         img:require('../assets/rj/zp.png'),
                //         title:'车间场景'
                //     },
                //     {
                //         img:require('../assets/rj/zp.png'),
                //         title:'车间场景'
                //     },     {
                //         img:require('../assets/rj/zp.png'),
                //         title:'车间场景'
                //     }
                //
                // ]
            }
        },
        props:['environmental'],
        components:{
            swiper, swiperSlide
        }
    }
</script>

<style lang="scss" scoped>
.honor{
    width:80%;
    margin: 60px auto;
    animation-duration: 3s;
    .title{
        width:100%;
        position: relative;
        text-align: center;
        p:nth-child(1){
            font-size: 30px;
            color:rgba(234, 84, 5, .3);
            text-transform: uppercase;
            font-family: "Geometric";
        }
        p:nth-child(2){
            text-align: center;
            color:#343434;
            position: absolute;
            left:0;
            bottom:-5px;
            font-size: 20px;
            width:100%;
            font-family: "SourceHanSansCN-Medium";
        }
    }
    .allImgs{
        width:100%;
        margin: 60px auto;
        margin-top: 80px;
        position: relative;
        &::after{
            content:'';
            background-color: #EA5404;
            height:1px;
            width:90%;
            position: absolute;
            left:5%;
            bottom:119px;
        }
        .lc{
            width:6px;
            height:6px;
            background:rgba(255,255,255,1);
            border-radius:50%;
            position: absolute;
            border: 1px solid #EA5404;
            left:4.5%;
            bottom:115px;
        }
        .rc{
            width:6px;
            height:6px;
            background:rgba(255,255,255,1);
            border-radius:50%;
            position: absolute;
            border: 1px solid #EA5404;
            right:4.5%;
            bottom:115px;
        }
        .swiper{
            width:100%;
            .item{
               display:flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                .one{
                    width:100%;
                    text-align: center;
                    overflow: hidden;
                    img{
                        transform: scale(.5);
                        transition: all 600ms;
                        width:100%;
                        display: block;
                        object-fit: contain;
                    }
                }
                p{
                    color:#343434;
                    font-family: "SourceHanSansCN-Regular";
                    margin: 30px auto;
                    position: relative;
                    padding: 30px 0;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    &::before{
                        width:10px;
                        height:10px;
                        background:rgba(234,84,4,1);
                        border-radius:50%;
                        content:'';
                        display: inline-block;
                        transform: translateY(-30px);
                    }
                }
            }
            .swiper-slide-active{
                .one{
                    img{
                        transform: scale(1);
                    }
                }
            }
        }
        .swiper2{
            display: none;
        }
    }
    @media screen and (max-width: 1000px){
        margin: 0 auto;
    .allImgs{
        margin-top: 30px;
        .swiper{
            display: none;
        }
        .swiper2{
            display: block;
        }
    }
    }
}
</style>
